export const floatingButton = (id: string, value = false) => {
  const element: any = document.getElementById(id)
  if (element) {
    element.checked = value
  }
}
